/**
 * streamlines add a dynamic value to padding-right.
 * @param {object} param0
 * @param {number|string} param0.$paddingRight
 * @returns {string}
 */
const dynPaddingRight = ({ $paddingRight }) => {
  if ($paddingRight === undefined) return "";
  if (typeof $paddingRight === "number")
    return `padding-right: ${$paddingRight}px;`;
  return `padding-right: ${$paddingRight};`;
};

export default dynPaddingRight;
